import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { VirtualKeyboardService } from 'ib/internetbank-fields/field-components/input-field/keyboard-toggle/virtual-keyboard.service';

import { DeprecatedPopUpService } from '../../../ui/controls/pop-up/pop-up.service';
import { AuthorizationService } from '../../authorization.service';
import { BiometricsRegistrationErrorPopUpComponent } from '../biometrics-registration-error-pop-up/biometrics-registration-error.pop-up.component';
import { BiometricsRegistrationSuccessPopUpComponent } from '../biometrics-registration-success-pop-up/biometrics-registration-success.pop-up.component';
import { BiometricsRegistrationWizardComponent } from '../biometrics-registration-wizard/biometrics-registration-wizard.component';

@Component({
	selector: 'app-biometrics-registratio-pop-up',
	templateUrl: './biometrics-registration.pop-up.component.html',
	styleUrls: ['./biometrics-registration.pop-up.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class BiometricsRegistrationPopUpComponent implements OnInit {

	@Input()
	public biometricsRegistrationErrorPopUpComponent: BiometricsRegistrationErrorPopUpComponent;

	@Input()
	public biometricsRegistrationSuccessPopUpComponent: BiometricsRegistrationSuccessPopUpComponent;


	@Output()
	public closeWindow: EventEmitter<boolean> = new EventEmitter();

	@ViewChild(BiometricsRegistrationWizardComponent)
	public biometricsRegistrationWizardComponent: BiometricsRegistrationWizardComponent;


	public readonly popUpId = 'biometrics-registration-pop-up-id';

	public isOpen: boolean;

	constructor(
		private modalService: DeprecatedPopUpService,
		private authorizationService: AuthorizationService,
		private virtualKeyboardService: VirtualKeyboardService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private changeDetectorRef: ChangeDetectorRef,
	) {
	}


	public openModal(id: string): void {
		this.modalService.open(id);
	}

	public closeModal(id: string): void {
		this.closeWindow.emit(false);
		this.modalService.close(id);

		// переинициализация, для последующих открытий диалогового окна
		this.biometricsRegistrationWizardComponent.initWizard();
	}

	public ngOnInit(): void {

	}

	public showPopUp(): void {

		this.openModal(this.popUpId);

		this.isOpen = true;

		this.changeDetectorRef.markForCheck();
	}

	public close(): void {
		this.closeModal(this.popUpId);
	}

}
